<template>
  <b-alert
    v-if="phoneControl.status"
    class="mt-1 pt-1"
    variant="primary"
    show
  >
    <div class="alert-body text-center">
      <FeatherIcon icon="InfoIcon" />
      <div class="pb-1">
        Bu telefon numarası başka bir Tedarikçi kartında kullanılmaktadır.
      </div>
      <div class="pb-1">
        <b-button
          variant="primary"
          :to="'/suppliers/view/' + phoneControl.id"
          size="sm"
        >
          Tedarikçi Kartı Görüntüle
        </b-button>
      </div>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'

export default {
  name: 'PhoneAlert',
  components: {
    BAlert, BButton,
  },
  computed: {
    dataItem() {
      return this.$store.getters['suppliers/dataItem']
    },
    phoneControl() {
      return this.$store.getters['suppliers/phoneControl']
    },
  },
}
</script>
